import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2)
    return parts
      .pop()
      .split(";")
      .shift();
}

const routerGuards = (to, from, next) => {
  const cookie = getCookie("token");
  if (cookie) {
    next();
  } else {
    next({
      path: "/login"
    });
  }
};

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("./views/Login")
    },
    {
      path: "/new-order/:id",
      name: "new-order",
      component: () => import("./views/NewOrder"),
      beforeEnter: routerGuards
    },
    {
      path: "/choose-customer",
      name: "choose-customer",
      component: () => import("./views/ChooseCustomer"),
      beforeEnter: routerGuards
    },
    {
      path: "/bar-code",
      name: "bar-code",
      component: () => import("./views/BarCode")
    },
    {
      path: "/home",
      name: "home",
      component: () => import("./views/Home"),
      children: [
        {
          path: "",
          name: "today-delivery",
          component: () => import("./views/TodayDelivery")
        },
        {
          path: "/order-settled",
          name: "order-settled",
          component: () => import("./views/OrderSettled")
        },
        {
          path: "/customer-information",
          name: "customer-information",
          component: () => import("./views/CustomerInfo")
        },
        {
          path: "/view-order/:id",
          name: "view-order",
          component: () => import("./views/ViewOrder")
        },
        {
          path: "/monthly-revenue",
          name: "monthly-revenue",
          component: () => import("./views/MonthRevenue")
        }
      ],
      beforeEnter: routerGuards
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
